var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1228_2411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1228_2411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50208 10.681C2.87681 10.681 2.34514 10.4617 1.90708 10.0229C1.46903 9.58403 1.25 9.05118 1.25 8.42438C1.25 7.79743 1.46889 7.26632 1.90667 6.83104C2.34431 6.39563 2.87576 6.17792 3.50104 6.17792C4.12646 6.17792 4.65819 6.39604 5.09625 6.83229C5.53417 7.26854 5.75312 7.79826 5.75312 8.42146C5.75312 9.0491 5.53431 9.58264 5.09667 10.0221C4.65889 10.4614 4.12736 10.681 3.50208 10.681ZM2.08333 15.5127V14.1667H17.9167V15.5127H2.08333ZM10.0004 10.6731C9.37514 10.6731 8.84347 10.4542 8.40542 10.0165C7.96736 9.57882 7.74833 9.04729 7.74833 8.42188C7.74833 7.7966 7.96722 7.26493 8.405 6.82688C8.84278 6.38896 9.37431 6.17 9.99958 6.17C10.6249 6.17 11.1565 6.38882 11.5946 6.82646C12.0326 7.26424 12.2517 7.79576 12.2517 8.42104C12.2517 9.04632 12.0328 9.57799 11.595 10.016C11.1572 10.4541 10.6257 10.6731 10.0004 10.6731ZM16.499 10.6731C15.8735 10.6731 15.3418 10.4542 14.9038 10.0165C14.4658 9.57882 14.2469 9.04729 14.2469 8.42188C14.2469 7.7966 14.4657 7.26493 14.9033 6.82688C15.3411 6.38896 15.8726 6.17 16.4979 6.17C17.1232 6.17 17.6549 6.38882 18.0929 6.82646C18.531 7.26424 18.75 7.79576 18.75 8.42104C18.75 9.04632 18.5311 9.57799 18.0933 10.016C17.6557 10.4541 17.1242 10.6731 16.499 10.6731Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.e467e0a5445394c47a0b269963a1d2b2.svg";
export { ForwardRef as ReactComponent };